<template>
  <div>
    <vue-headful :title="title" />
    <h3 class="page-header mt-2">{{title}}</h3>
    <NextGame v-if="data.games && team" v-bind:data="data.games"></NextGame>
    <Ranking v-if="data.ranking" v-bind:data="data.ranking" />
    <Calendar v-if="data.games" v-bind:data="data.games" />
    <Results v-if="data.games" v-bind:data="data.games" />
  </div>
</template>

<script>
import axios from "axios";
import Ranking from "./Ranking.vue";
import Results from "./Results.vue";
import Calendar from "./Calendar.vue";
import NextGame from "./NextGame.vue";

export default {
  name: "FederationSeries",
  props: {
    federation: String,
    series: String,
    team: String
  },
  data() {
    return {
      data: [],
      errors: [],
      title: ""
    };
  },
  created() {
    axios
      .get(
        `https://sport-scoresapi-v220181029094510.azurewebsites.net/api/${this.federation}/${this.series}`
        // `http://localhost:55344/api/${this.federation}/${this.series}`
      )
      .then(response => {
        this.data = response.data.result;
        if (this.team) {
          let rankingTeam = this.data.ranking.find(x =>
            x.name.toUpperCase().includes(this.team.toUpperCase())
          );
          if (rankingTeam) {
            let team = rankingTeam.name;
            this.team = team;
            this.data.games = this.data.games.filter(
              x => x.homeTeam == team || x.outTeam == team
            );
          }
        }
        this.data.games.forEach(x => (x.isPassed = this.isPassed(x)));

        this.title = `${this.federation.toUpperCase()} - ${this.series}`;
        if (this.team) this.title = this.title.concat(` - ${this.team}`);
      })
      .catch(e => {
        this.errors.push(e);
      });
  },
  methods: {
    isPassed: function(game) {
      let now = new Date();
      now.setHours(now.getHours() + 2);
      return new Date() > new Date(game.date);
    }
  },
  components: {
    NextGame,
    Ranking,
    Results,
    Calendar
  }
};
</script>
